module.exports = __webpack_public_path__ + "img/c6b1106.jpg";